import React, { useState } from "react";

import "./menuEditor.css";

const MenuEditorEmployee = ({ menu, handleSaveMenu, handleCancel }) => {
  const [menuInEdit, setMenuInEdit] = useState({ ...menu });

  // to sort dishes
  const sortDishesByCategory = (A, B) => {
    let a = A.dishBody.category.toLowerCase();
    let b = B.dishBody.category.toLowerCase();
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  };

  const handleDishQuantityInputChange = (e, dishId) => {
    const workingMenu = { ...menuInEdit };
    let workingDishesArray = [...workingMenu.dishes];
    let dishIndex = workingDishesArray.findIndex((dish) => dish._id === dishId);

    workingDishesArray[dishIndex].quantity = e.target.value;

    workingMenu.dishes = [...workingDishesArray];

    setMenuInEdit({ ...workingMenu });
  };

  return (
    <div className="menuComponent">
      <div className="menuComponent__menuBodyDiv">
        <div className="menuBodyDiv__congifDiv">
          <div className="congifDiv__menuName">
            <h3 className="menuComponent__subheading">MENU NAME</h3>
            <div>{menu.name ? menu.name : "no name"}</div>
          </div>
          <div className="congifDiv__menuDescription">
            <h3 className="menuComponent__subheading">MENU DESCRIPTION</h3>
            <div style={{ textAlign: "center" }}>
              {menu.description ? menu.description : "no description"}
            </div>
          </div>
        </div>
        <div className="menuBodyDiv__dishesDiv">
          {menuInEdit.dishes &&
            menuInEdit.dishes
              .sort(sortDishesByCategory)
              .map((menuDish, index, sortedArray) => (
                <div
                  className="dishesDiv__dishItem"
                  key={menuDish.dishBody._id}
                >
                  <div className="dishItem__category">
                    {(sortedArray[index - 1] &&
                      sortedArray[index - 1].dishBody.category) ===
                    menuDish.dishBody.category
                      ? ""
                      : menuDish.dishBody.category}
                  </div>
                  <div className="dishItem__name">{menuDish.dishBody.name}</div>
                  <div className="dishItem__quantity">
                    in stock:
                    <input
                      type="number"
                      name="dishQuantity"
                      id={`dishQuantity${menuDish._id}`}
                      value={menuDish.quantity}
                      onChange={(e) =>
                        handleDishQuantityInputChange(e, menuDish._id)
                      }
                    />
                  </div>
                </div>
              ))}
        </div>
      </div>
      <div className="menuComponent__controlsDiv">
        <button
          className="controlsDiv__saveEditMenuBtn"
          onClick={() => handleSaveMenu(menu._id, menuInEdit)}
        >
          SAVE
        </button>
        <button
          className="controlsDiv__cancelEditMenuBtn"
          onClick={() => handleCancel()}
        >
          CANCEL
        </button>
      </div>
    </div>
  );
};

export default MenuEditorEmployee;
